/** @jsx h */
import { h } from 'preact'
import Slider from '../../journeys/Slider'

const StoryCard = props =>
  <article class={`ClaimCard StoryCard ${props.revealed ? 'StoryCard--revealed' : ''}`}>
    <h3 class='StoryCard-title'>{props.title}</h3>
    <div class='ModalCard-content'>
      <Slider {...props} journeyBrandDisabled helpButtonDisabled />
    </div>
  </article>

export default StoryCard
